<ul class="shipment-summary" *ngIf="s.shipment">
   <li class="summarylistitem">
      <a id="shipmentSummary" (click)="scrollToTop()" class="h1" color="accent">SHIPMENT SUMMARY</a>
   </li>

   <ng-container *ngIf="quotationId != null">
      <li>
         <a title="quotationId">Quotation Number</a>
         <div id="quotationId">{{ quotationId }}</div>
      </li>
   </ng-container>

   <ng-container *ngIf="cost != null">
      <li>
         <a title="quotationId">Quotation Cost</a>
         <div id="quotationCost">{{ cost | currency }}</div>
      </li>
   </ng-container>

   <li>
      <a  title="type">Booking Type</a>
      <div id="bookType">
         {{s.shipType | titlecase}}
         <span *ngIf="s.shipType === 'international'"> - {{s.mode | titlecase}}</span>
      </div>
   </li>

   <li *ngIf="s.shipment.shipper && s.shipment.shipper.name">
      <a  title="shipper">Shipper</a>
      <div id="shipperName">{{s.shipment.shipper.name}}</div>
      <div *ngIf="s.shipment['origin'] as origin">
         Leaving {{s.shipment.shipper.country}} - {{origin}}
      </div>
   </li>

   <li *ngIf="s.shipment.consignee && s.shipment.consignee.name">
      <a  title="consignee">Consignee</a>
      <div id="consigneeName">{{s.shipment.consignee.name}}</div>
      <div *ngIf="s.shipment['destination'] as destination">
         Arriving at {{s.shipment.consignee.country}} - {{destination}}
      </div>
   </li>

   <li *ngIf="s.shipment.servicelevel">
      <a  title="servicelevel">Service Level</a>
      <div id="servicelevel" *ngIf="s.shipment.servicelevel">{{s.shipment.servicelevel}}</div>
   </li>

   <li *ngIf="s.shipment.pdatefrom || s.shipment.pdateto || s.shipment.ddatefrom || s.shipment.ddateto">
      <a title="dates">Dates</a>
      <div id="pDate" *ngIf="s.shipment.pdatefrom || s.shipment.pdateto">
         <span>Pickup </span>
         <span id="pDateFrom" *ngIf="s.shipment.pdatefrom">{{s.shipment.pdatefrom | date: 'shortDate'}}</span>
         <span *ngIf="s.shipment.pdatefrom && s.shipment.pdateto"> to </span>
         <span id="pDateTo" *ngIf="s.shipment.pdateto">{{s.shipment.pdateto | date: 'shortDate'}}</span>
      </div>

      <div id="dDate" *ngIf="s.shipment.ddatefrom || s.shipment.ddateto">
         <span>Delivery </span>
         <span id="dDateFrom" *ngIf="s.shipment.ddatefrom">{{s.shipment.ddatefrom | date: 'shortDate'}}</span>
         <span *ngIf="s.shipment.ddatefrom && s.shipment.ddateto"> to </span>
         <span id="dDateTo" *ngIf="s.shipment.ddateto">{{s.shipment.ddateto | date: 'shortDate'}}</span>
      </div>
   </li>

   <li *ngIf="s.shipment?.accessorials?.length">
      <a  title="accessorials">Accessorials</a>
      <div *ngIf="s.shipment.accessorials.length as length">
         {{length}} {{'Item' | plural : length}}
      </div>
   </li>

   <li *ngIf="s.shipment.calculator && (s.shipment.calculator.length > 1 || calcDisabled)">
      <a  title="calculator">Item Calculator</a>
      <div id="calculatorItems">{{
      calcDisabled ? (s.shipment.calculator.length | number) :
      (s.shipment.calculator.length - 1 | number)
      }} Items</div>
      <div id="calculatorPieces" *ngIf="s.shipment.calculator | total : 'pieces' as pieces">
         {{pieces | number}} {{'Piece' | plural : pieces}}
      </div>
      <div id="calculatorWeight" *ngIf="s.shipment.calculator | totalweight">
         {{s.shipment.calculator | totaldualweight}}
      </div>
      <div id="calculatorVolume" *ngIf="s.shipment.calculator | totalvolume">
         {{s.shipment.calculator | totaldualvolume}}
      </div>
   </li>

   <li *ngIf="s.shipment['containers'] && s.shipment['shippingType'] === 'FCL'">
      <a  title="containers">Item Calculator</a>
      <div id="containerType">Type {{s.shipment['shippingType']}} {{s.shipment['itemized'] ? '- Itemized' : ''}}</div>
      <div id="containerCount" *ngIf="s.shipment['containers'].length as length">
         {{length | number}} {{'Container' | plural : length}}
      </div>
   </li>

   <li *ngIf="s.shipment?.references?.length">
      <a  title="references">Reference Details</a>
      <div id="references" *ngIf="s.shipment.references.length as length">
         {{length}} {{'Item' | plural : length}}
      </div>
   </li>

   <li *ngIf="s.shipment.tradeshow && s.shipment.tradeshow.length && s.shipment.tradeshow[0].name">
      <a  title="tradeshow">Tradeshow Details</a>
      <div [id]="'tradeshow'+(t.location | titlecase)" *ngFor="let t of s.shipment.tradeshow">
         {{t.location | titlecase}} {{t.name}}
      </div>
   </li>

   <ng-container *ngIf="s.shipment.risks as risks">
      <li *ngIf="(risks.type && risks.amount && risks.currency) || risks.dangerousGoods">
         <a  title="risks">Risks</a>
         <div id="risks" *ngIf="risks.type && risks.amount && risks.currency">
            {{risks.type | spacers | titlecase}} {{risks.amount | currencycode : risks.currency}}
         </div>
         <div id="dangerousGoods" *ngIf="risks.dangerousGoods" color="warn">Dangerous Goods</div>
      </li>
   </ng-container>

   <li *ngIf="(s.shipment.cod && s.shipment.cod.type) || s.shipment.description || s.shipment.specialinstructions">
      <a  title="description">Description and Instructions</a>
      <ng-container *ngIf="s.shipment.cod as cod">
         <div id="cod" *ngIf="cod && cod.type">
            <span>COD</span>
            <span id="codType"> {{cod.type | titlecase}}</span>
            <span id="codAmount" *ngIf="cod.amount"> {{cod.amount | currencycode : cod.currency}}</span>
         </div>
      </ng-container>
      <div id="description" >{{s.shipment.description}}</div>
      <div id="specialinstructions">{{s.shipment.specialinstructions}}</div>
   </li>

   <ng-container *ngIf="s.shipment['customs'] as customs">
      <li *ngIf="customs.value && customs.currency">
         <a  title="customs">Customs</a>
         <div id="customs">{{customs.value | currencycode : customs.currency}}</div>
      </li>
   </ng-container>

   <ng-container *ngIf="s.shipment.attachments as attachments">
      <li *ngIf="attachments.length as length">
         <a  title="attachments">Attachments</a>
         <div id="attachments">{{length}} {{'Attachment' | plural : length}}</div>
      </li>
   </ng-container>
</ul>
